





































































import { defineComponent, ref, computed } from '@vue/composition-api';
import Workbench, { WorkbanchInterface } from './components/Workbench.vue';
import EmailModal from './components/EmailModal.vue';
import DealerModal from './components/DealerModal.vue';
import WeightInfoModal from './components/modals/WeightInfoModal.vue';
import formatNumber from './functions/formatNumber';
import postOpen from './functions/postOpen';
import getJson from './functions/getJson';
if (process.env.NODE_ENV === 'development') {
  console.log("process.env.NODE_ENV === 'development'")
  import("../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.css")
  .then((something) => {
      console.log('something is ', something);
  });
} else {
  console.log("process.env.NODE_ENV ! === 'development'", process.env.NODE_ENV)
}


import logic from './logic';

export default defineComponent({
  name: 'App',
  components: {
    Workbench,
    EmailModal,
    DealerModal,
    WeightInfoModal,
  },
  provide () {
    return {
      setWeightInfoData: this.setWeightInfoData
    };
  },
  setup() {
    getJson(process.env.VUE_APP_DATA_URL).then(data => {
			logic.setData(data);
      add();
		});

    const weightInfoData = ref({})
    const workbenches = ref<WorkbanchInterface[]>([]);
    const prices = ref<number[]>([]);
    const accessories = ref([]);
    const isAllDone = computed(() => workbenches.value.every((workbench) => workbench.isDone));
    const quantity = computed(() => workbenches.value.reduce((a: number, c: any) => a + c.quantity, 0));
    const sum = ref(0);
    const pdfData = computed(() => JSON.stringify({
      rows: workbenches.value.map((item, i) => ({ ...item, price: prices.value[i] })),
      accessories: Object.values(accessories.value),
    }));

    const setWeightInfoData = (weightOption) => {
      weightInfoData.value = weightOption
    }

    const add = () => {
      workbenches.value.push({
        isDone: false,
        quantity: 1,
        id: new Date().getTime()
      } as WorkbanchInterface);
    };

    const remove = (index: number) => {
      workbenches.value.splice(index, 1);
      if (index == 0 && workbenches.value.length === 0) {
        add();
      }
      updateAccessories();
    };

    const edit = (index: number) => {
      workbenches.value[index].isDone = false;
      workbenches.value = [...workbenches.value];
    };

    const update = (index: number, workbench: WorkbanchInterface) => {
      console.log('update', index, workbench);

      workbenches.value[index] = workbench;
      workbenches.value = [...workbenches.value];
      updateAccessories();
    };

    const updateAccessories = () => {
      prices.value.length = 0;
      const allComponents = workbenches.value.map((workbench, i) => {
        const workbenchComponents = logic.getWorkbenchComponents(workbench);
        prices.value[i] = workbenchComponents.reduce((a: number, c: any) => a + c.price * c.quantity / workbench.quantity, 0);
        return workbenchComponents;
      }).reduce((a: any[], c: any[]) => a.concat(c));
      sum.value = allComponents.reduce((a: number, c: any) => a + c.price * c.quantity, 0);
      accessories.value = allComponents.reduce((a: any, c:any) => {
        if (a[c.name]) {
          a[c.name].quantity += c.quantity;
          a[c.name].sum += c.sum;
        } else {
          a[c.name] = c;
        }
        return a;
      }, {});
    };

    const print = (download = false) => {
      postOpen(process.env.VUE_APP_PDF_URL, {
        download: Number(download),
        data: pdfData.value,
      }, download);
    };

    const download = () => {
      print(true);
    };

    return {
      workbenches,
      prices,
      accessories,
      isAllDone,
      quantity,
      sum,
      pdfData,
      add,
      remove,
      edit,
      update,
      updateAccessories,
      formatNumber,
      print,
      download,
      weightInfoData,
      setWeightInfoData
    };
  },
})
